<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">{{ pageTitle }}</h3>
          </div>
          <div class="box-body">

            <el-card class="box-card" shadow="never">
              <div class="query">
                <el-form :inline="true">
                  <el-form-item label="搜索">
                    <el-input v-model="query.keyword" clearable placeholder="输入企业名称搜索"></el-input>
                  </el-form-item>
                  <el-form-item label="状态">
                    <el-select v-model="query.status" placeholder="请选择状态">
                      <el-option label="全部" :value="0"></el-option>
                      <el-option label="待开票" :value="1"></el-option>
                      <el-option label="已开票" :value="2"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" :disabled="loading" @click="querySearch">查询</el-button>
                  </el-form-item>
                </el-form>
              </div>

              <el-table :data="list" border style="width: 100%" v-loading="loading">
                <el-table-column prop="organize_name" label="申请企业"></el-table-column>
                <el-table-column prop="admin_name" label="申请人"></el-table-column>
                <el-table-column prop="type_desc" label="发票类型"></el-table-column>
                <el-table-column prop="name" label="抬头名称"></el-table-column>
                <el-table-column prop="tax_no" label="税号"></el-table-column>
                <el-table-column prop="amount" label="开票金额" width="80"></el-table-column>
                <el-table-column prop="create_at" label="申请时间"></el-table-column>
                <el-table-column label="开票状态" width="80">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.status === 1">{{ scope.row.status_desc }}</el-tag>
                    <el-tag v-if="scope.row.status === 2" type="success">{{ scope.row.status_desc }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="200">
                  <template slot-scope="scope">
                    <div style="display: flex;align-items: center;">
                      <page-detail :param="scope.row" @finish="finish">{{ scope.row.status === 2 ? '开票详情' : '开票'}}</page-detail>
                    </div>
                  </template>
                </el-table-column>
              </el-table>

              <div v-if="list.length > 0">
                <div style="height: 20px;"></div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :current-page="query.page"
                    :page-size="query.size"
                    :total="total"
                    @current-change="pageSelect"
                >
                </el-pagination>
              </div>

            </el-card>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import {mapState} from "vuex";

import PageDetail from "@/views/order/invoice/Detail.vue";

export default {
  components: {
    PageDetail,
  },
  data() {
    return {
      loading: false,
      query: {
        type_id: 0,
        status: 0,
        keyword: '',
        page: 1,
        size: 10
      },
      list: [],
      total: 0,
      canNext: false,
      nextPage: 1,
      typeList: [],
    };
  },
  computed: mapState({
    config: (state) => state.config,
    pageTitle: (state) => state.pageTitle,
  }),
  mounted() {
    const _this = this;
    _this.query = Object.assign(_this.query, _this.$route.query)
    _this.query.status = parseInt(_this.query.status);
    _this.query.page = parseInt(_this.query.page);
    _this.query.size = parseInt(_this.query.size);
    _this.loading = true;
    _this.$store
        .dispatch('authInit', _this)
        .then(() => {
          _this.loadList();
        })
        .catch(() => {
          _this.loading = false;
        })
  },
  methods: {
    updateUrl() {
      const _this = this;
      const url = _this.$queryUrl(_this.$route.path, _this.query);
      _this.$router.replace({path: url});
    },
    querySearch() {
      const _this = this;
      _this.query.page = 1;
      _this.loading = true;
      _this.loadList();
    },
    pageSelect(page) {
      const _this = this;
      _this.query.page = parseInt(page);
      _this.loading = true;
      _this.loadList();
    },
    loadList() {
      const _this = this;
      _this.$apiAdmin.adminInvoiceList(_this.query)
          .then(res => {
            _this.loading = false;
            _this.list = res.list;
            _this.total = res.total;
            _this.canNext = res.can_next;
            _this.nextPage = res.next_page;
            _this.updateUrl();
          })
          .catch(err => {
            _this.loading = false;
            _this.updateUrl();
          })
    },
    finish(res) {
      const _this = this;
      _this.loading = true;
      _this.loadList();
    },
  }
}
</script>


<style scoped>
.custom-tree-node {
  display: flex;
  justify-content: space-between;
}

.custom-tree-node-name {
  width: 400px;
}
</style>